/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://cdn.book.get-e.com/v4.54.0/scripts/modules";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 11);
/******/ })
/************************************************************************/
/******/ ({

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/assets/scripts/services/script-loader.ts
function loadScript(url, options) {
    if (options === void 0) { options = {}; }
    var isLoaded = document.querySelectorAll('.search-script');
    if (isLoaded.length > 0) {
        return;
    }
    var script = document.createElement('script');
    script.src = url;
    if (options && options.id) {
        script.id = options.id;
    }
    document.body.appendChild(script);
}

// CONCATENATED MODULE: ./src/assets/scripts/services/zendesk-chat.ts

function loadChat() {
    window.addEventListener('message', function (event) {
        if (event.data === 'hideZendesk') {
            if (window.zE) {
                hideChat();
            }
        }
    });
    loadScript('https://static.zdassets.com/ekr/snippet.js?key=b4e35c30-14a2-4589-82e7-71d8bcaad6d0', {
        id: 'ze-snippet',
    });
}
function expandChat() {
    window.zE('messenger', 'open');
}
function hideChat() {
    window.zE('messenger', 'hide');
}

// CONCATENATED MODULE: ./src/assets/scripts/modules/home/_entry.standalone.ts

loadChat();


/***/ })

/******/ });


// WEBPACK FOOTER //
// home.js